<template>
  <div class="clm-main">
    <div class="clm-main__container clm-container">
      <div class="clm-main__block">
        <div class="clm-main__title" v-html="pageSubtitleTwo"></div>
        <ul class="clm-main__list">
          <li class="clm-main__item" v-for="(item, index) in listOfService" :key="index">
            <div class="clm-main__count">{{ '0' + (index + 1) }}</div>
            <div class="clm-main__text" v-html="item"></div>
          </li>
        </ul>
      </div>
			<div class="clm-form">
      <div class="clm-form__container">
        <div class="clm-form__block">
          <auth-form :transition-active="false" :page-params="pageParams"/>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import authForm from "../../auth-form/auth-form.vue";
export default {
  name: "the-auth-main",
	components: {
    authForm
  },
  props: {
    pageSubtitleTwo: String,
    listOfService: {
      type: Array,
      default: []
    },
		pageParams: Object
  },
}
</script>